import {
  Component,
  Input,
  NgModule,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { OptionFormData } from "../../../../model/calculation/optionFormData";
import { MatrixColumnFormData } from "../../../../model/calculation/optionPriceInformation";
import { ColumnFormPopupMoule } from "../option-data-grid-cartons/column-form-popup/column-form-popup.component";
import { CommonModule } from "@angular/common";
import { ConfirmationDialogModule } from "../../../confirmation-dialog/confirmation-dialog.component";
import {
  DxButtonModule,
  DxDataGridComponent,
  DxDataGridModule,
  DxFormComponent,
  DxFormModule,
  DxTemplateModule,
} from "devextreme-angular";
import {
  DxiColumnModule,
  DxoEditingModule,
  DxoPagingModule,
} from "devextreme-angular/ui/nested";
import { MatrixColumnFormPopupModule } from "./matrix-column-form-popup/matrix-column-form-popup.component";
import { formatMessage } from "devextreme/localization";
import { ValidationPattern } from "../../../../utils/patternUtils";
import { AlertModule } from "../../../alert/alert.component";

@Component({
  selector: "app-option-data-grid-matrix",
  templateUrl: "./option-data-grid-matrix.component.html",
  styleUrls: ["./option-data-grid-matrix.component.scss"],
})
export class OptionDataGridMatrixComponent implements OnInit, OnChanges {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  formatMessage = formatMessage;

  @Input() optionData: OptionFormData;

  //Edit or Create
  formCaption: string;

  columnFormPopupVisible = false;
  columnFormData: MatrixColumnFormData;

  columnDialogVisible: boolean = false;
  columnDialogMessage: string;
  columnDialogData: any;

  // represents 1 or 2
  // if from and to visible 2
  // if only to visible 1
  indexSubtractor: number;

  numberPattern = ValidationPattern.ONLY_DECIMAL;

  showFromToOverlapAlert: boolean = false;
  showColumn0ValueAlert: boolean = false;
  showColumnAlreadyExistsAlert: boolean = false;

  constructor() {
    this.validateColumnCells = this.validateColumnCells.bind(this);
    this.onUpdateDeleteCreate = this.onUpdateDeleteCreate.bind(this);
    this.calculateFromValues = this.calculateFromValues.bind(this);
    this.validateFromAndToValues = this.validateFromAndToValues.bind(this);
  }

  ngOnInit(): void {
    //this.sortColumns();
  }

  ngOnChanges(changes: SimpleChanges) {
    if ("optionData" in changes) {
      //this.sortColumns();
    }
  }

  createColumn() {
    this.formCaption = formatMessage("option.column.create");
    this.columnFormData = new MatrixColumnFormData();
    this.columnFormPopupVisible = true;
  }

  saveColumnData(data: MatrixColumnFormData): void {
    // Check if valueTo already exists
    const valueToExists = this.optionData.columns.some(
      (column) => column.valueTo === data.valueTo
    );

    if (valueToExists) {
      // Display a warning if valueTo already exists
      this.showColumnAlreadyExistsAlert = true; // Reuse the existing alert mechanism
      //this.sortColumns();
      return;
    }

    if (data.index === -1) {
      // Add a new column and sort based on valueTo
      this.optionData.columns.push({ valueTo: data.valueTo });
      //this.optionData.columns.sort((a, b) => a.valueTo - b.valueTo);
      this.ensureDataIntegrity();
    } else {
      // Update an existing column
      this.optionData.columns[data.index] = {
        valueTo: data.valueTo,
      };
      //this.optionData.columns.sort((a, b) => a.valueTo - b.valueTo);
    }

    //this.sortColumns();
  }

  showColumnConfirmationDialog(data) {
    this.columnDialogData = data;
    this.columnDialogMessage = formatMessage(
      "option.column.delete.message",
      data.column.caption
    );
    this.columnDialogVisible = true;
  }

  deleteColumnData(data): void {
    const colIndex = data.columnIndex - this.indexSubtractor;
    const columnLength = this.optionData.columns.length;
    const optionPriceInformationLength =
      this.optionData.optionPriceInformation.length;

    if (colIndex !== -1 && optionPriceInformationLength > 0) {
      for (let i = 0; i < optionPriceInformationLength; i++) {
        for (let j = colIndex; j < columnLength; j++) {
          if (j == columnLength - 1) {
            delete this.optionData.optionPriceInformation[i][`column${j}`];
          } else {
            this.optionData.optionPriceInformation[i][`column${j}`] =
              this.optionData.optionPriceInformation[i][`column${j + 1}`];
          }
        }
      }
    }
    this.optionData.columns?.splice(colIndex, 1);
    if (this.optionData.columns.length == 0)
      this.optionData.optionPriceInformation = [];
    this.columnDialogVisible = false;
  }

  formatColumnCaption(columnName: any): string {
    return `${columnName.valueTo}`;
  }

  editColumn(data) {
    this.formCaption = formatMessage("option.column.edit");
    const colIndex = data.columnIndex - this.indexSubtractor;
    this.columnFormData = new MatrixColumnFormData(
      this.optionData.columns[colIndex],
      colIndex
    );
    this.columnFormPopupVisible = true;
    //this.sortColumns();
  }

  getDatafield(i: number): string {
    return `column${i}`;
  }

  isFromColumnVisible() {
    const visible = this.optionData.quantityType != "PAGE_COUNT";
    this.indexSubtractor = visible ? 2 : 1;
    return visible;
  }

  onUpdateDeleteCreate() {
    this.showColumn0ValueAlert = false;
    this.showFromToOverlapAlert = false;
    this.showColumnAlreadyExistsAlert = false;
    if (this.optionData.quantityType == "PAGE_COUNT")
      this.calculateFromValues();

    this.validateColumnCells();
    //this.sortColumns();
  }

  calculateFromValues() {
    const priceLength = this.optionData.optionPriceInformation.length;
    if (priceLength == 0) return;

    const priceInformations = this.optionData.optionPriceInformation;

    // sort asc
    priceInformations.sort((a, b) => {
      return a.to - b.to;
    });

    priceInformations.forEach((price, index) => {
      if (index == 0) {
        price.from = 0;
      } else {
        price.from = Number(priceInformations[index - 1].to) + 1;
      }
    });

    this.optionData.optionPriceInformation = priceInformations;
  }

  customizeFormItems(item: any) {
    item.editorOptions = { stylingMode: "underlined" };
  }

  ensureDataIntegrity() {
    const lastIndex = this.optionData.columns.length - 1;
    this.optionData.optionPriceInformation.forEach((price) => {
      price[`column${lastIndex}`] = 0;
    });
  }

  validateColumnCells() {
    const rows: any = this.dataGrid.instance
      .getVisibleRows()
      .filter((row) => row.rowType == "data");

    rows.forEach((row: any) => {
      row.cells?.forEach((cell) => {
        const {
          column: { dataField },
          value,
          cellElement,
        } = cell;
        if (dataField?.includes("column") && value == 0) {
          cellElement.style.backgroundColor = "rgb(242, 222, 222)";
          this.showColumn0ValueAlert = true;
        }
      });
    });

    if (this.optionData.quantityType != "PAGE_COUNT") {
      this.validateFromAndToValues(rows);
    }
  }
  validateFromAndToValues(rows) {
    if (rows.length <= 1) return;

    rows.forEach((parentRow: any, index) => {
      rows.forEach((r, i) => {
        if (i == index) {
          return;
        }

        if (!this.rowValid(parentRow, r)) {
          parentRow.cells?.forEach((cell) => {
            const {
              column: { dataField },
              value,
              cellElement,
            } = cell;
            if (dataField == "from" || dataField == "to") {
              cellElement.style.backgroundColor = "rgb(242, 222, 222)";
              this.showFromToOverlapAlert = true;
            }
          });
        }
      });
    });
  }

  // This Function Checks if the From and To Values of a Row
  // Overlap with an other Row:
  // From:100 To:200
  // From:50 To: 150
  // they would overlap
  rowValid(parent, validateAgainst): boolean {
    const currentFrom = parent.data.from;
    const currentTo = parent.data.to;

    const toValidateFrom = validateAgainst.data.from;
    const toValidateTo = validateAgainst.data.to;

    return (
      (currentFrom > toValidateFrom && currentFrom > toValidateTo) ||
      (currentFrom < toValidateFrom && currentTo < toValidateFrom)
    );
  }

  validateFromAndTo(e) {
    const {
      data: { from, to },
    } = e;
    if (!to || !from) {
      return true;
    }
    return from < to;
  }

  sortColumns() {
    setTimeout(() => {
      const sortedValueToArray = this.optionData.columns
        .map((column) => Number(column.valueTo))
        .sort((a, b) => a - b);

      sortedValueToArray.forEach((sortedValue, index) => {
        const columnIndex = this.optionData.columns.findIndex(
          (column) => Number(column.valueTo) === sortedValue
        );

        if (columnIndex !== -1) {
          const offset = this.optionData.quantityType === "PAGE_COUNT" ? 1 : 2;
          this.dataGrid.instance.columnOption(
            columnIndex + offset,
            "visibleIndex",
            index + offset
          );
        }
      });

      if (this.optionData.quantityType === "PAGE_COUNT") {
        this.dataGrid.instance.columnOption(0, "visibleIndex", 0);
      } else if (this.optionData.quantityType === "ORDER_QUANTITY") {
        this.dataGrid.instance.columnOption(0, "visibleIndex", 0);
        this.dataGrid.instance.columnOption(1, "visibleIndex", 1);
      }

      this.dataGrid.instance.repaint();
    }, 1);
  }
}

@NgModule({
  imports: [
    ColumnFormPopupMoule,
    CommonModule,
    ConfirmationDialogModule,
    DxButtonModule,
    DxDataGridModule,
    DxTemplateModule,
    DxiColumnModule,
    DxoEditingModule,
    DxoPagingModule,
    MatrixColumnFormPopupModule,
    AlertModule,
    DxFormModule,
  ],
  exports: [OptionDataGridMatrixComponent],
  declarations: [OptionDataGridMatrixComponent],
})
export class OptionDataGridMatrixModule {}
